import { TIME_RANGES } from "common/constants";
import { RootState } from "app/store";
import { WorkspaceType } from "@shared/types";
import { ReactNode } from "react";

export type TimeRange = (typeof TIME_RANGES)[number];
export type unixTimestamp = number;
export type Selector<T> = (state: RootState) => T;
export interface RequestStatus {
  isFetching: boolean;
  isFetched?: boolean;
}

export enum SortingOrder {
  DESCEND = -1,
  ASCEND = 1,
}

export enum SiderGroup {
  MONITORING = "Monitoring",
  TRADING = "Trading",
  PORTFOLIO = "Portfolio",
  OTHER = "Other",
  HELP = "Help",
}

export interface MenuItemConfig {
  icon?: ReactNode;
  link?: string;
  name: string;
  subName?: string;
  key: string;
  routerMatch?: string | string[];
  onClick?: () => void;
  subMenu?: Omit<MenuItemConfig, "subMenu">[];
  className?: string;
  isNewFeature?: boolean;
  group?: SiderGroup;
  exactMatch?: boolean;
}

export type WorkspaceToPathsMapping = {
  [workspaceKey in WorkspaceType]: string[];
};

export type GetUpdatedPathType = (
  queryToAppend?: string | Record<string, string>,
  queryKeysToDelete?: string[],
  nextLocation?: string
) => string;

export enum PageLayout {
  CARDS = 1,
  TABLE = 2,
}
